export const tags = [
  "late-work-manager",
  "policy-modal",
  "lwm-accept-modal",
  "lwm-reject-modal",
] as const;
